import { Link } from 'react-router-dom';
import { Icon, close, external, menu } from '@wordpress/icons';
import { useTranslate } from 'i18n-calypso';

import WPCloudLogo from 'components/wp-cloud-logo';
import ProfileDropdown from 'components/profile-dropdown';

import useShellNav from './use-shell-nav';

interface Props {
	hasNav: boolean;
	navOpen: boolean;
	navId: string;
	onToggleNav: () => void;
}

export default function AppHeader( { hasNav, navOpen, navId, onToggleNav }: Props ) {
	const translate = useTranslate();
	const { resources } = useShellNav();

	return (
		<header className="app-shell__header">
			{ hasNav && (
				<button
					type="button"
					className="app-shell__nav-toggle"
					aria-expanded={ navOpen }
					aria-controls={ navId }
					aria-label={ String( navOpen ? translate( 'Close navigation menu' ) : translate( 'Open navigation menu' ) ) }
					onClick={ onToggleNav }
				>
					<Icon icon={ navOpen ? close : menu } size={ 24 } />
				</button>
			) }

			<Link to="/" className="app-shell__logo" aria-label={ String( translate( 'WP Cloud partner portal home' ) ) }>
				<WPCloudLogo height={ 24 } title={ null } />
			</Link>

			{ resources.length > 0 && (
				<nav className="app-shell__header-links" aria-label={ String( translate( 'Resources' ) ) }>
					{ resources.map( link => (
						<a key={ link.key } className="app-shell__header-link" href={ link.href } target="_blank" rel="noreferrer">
							{ link.label }
							<Icon icon={ external } size={ 16 } className="app-shell__header-link-icon" aria-hidden="true" />
						</a>
					) ) }
				</nav>
			) }

			<div className="app-shell__profile">
				<ProfileDropdown compact />
			</div>
		</header>
	);
}
